import { render, staticRenderFns } from "./html-tag.vue?vue&type=template&id=484dda9e&"
import script from "./html-tag.vue?vue&type=script&lang=js&"
export * from "./html-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports